import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import nextArrow from "../../assets/nextArrow.png";

import { useState } from "react";

import "../ActiveOrder/activeorder.css";
import { useEffect } from "react";


import SwipeToVend from "../SwipVend/Swipvend";
import CircularTimer from "./timer";
import CancelSuccessModal from "./CancelSuccessModal";
import CancelErrorModal from "./canelErrorModel";
import CancelOrderModal from "./CancelOrderModal";
import {  Box, IconButton, Typography} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BusyMachineModal from "../VendOrder/BusyMachineModal";
import WaitingLoder from "../../Loader/component";




const modalStyles = {
  overlay: {
    
    top: 0,
    left: 0,
    width: '100%',
    
   
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modal: {
    backgroundColor: '#fff',
   
    borderRadius: '8px',
   /*  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)', */
    maxWidth: '500px',
    width: '90%',
 
    marginTop: "90px",
     marginBottom:"90px"
  
  },


  companyName:{
    fontFamily: 'Roboto, sans-serif',
    fontSize: '14px',
    paddingTop: '20px',
   
    paddingBottom:"5px",
    fontWeight: 500,
    lineHeight: '16.41px',
    letterSpacing: '0.02em',
    textAlign: 'start',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    color:"background: rgba(113, 129, 152, 1)"

  },
  address:{
    fontFamily: 'Roboto, sans-serif',
    fontSize: '12px',

    fontWeight: 400,
    lineHeight: '14.06px',
    textAlign: 'start',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    color: " rgba(113, 129, 152, 0.7)"
  },
  pickupCodeSection:{
    backgroundColor:"rgba(210, 238, 229, 0.1)",
    marginTop: "5vw"
  },
  textPickupCode:{

    fontFamily: 'Roboto, sans-serif',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '21.09px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    color: "rgba(56, 79, 111, 1)"

    },

    textPickupCodeSub:{

      fontFamily: 'Roboto, sans-serif',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '50px',
      letterSpacing: '0.2px',
      textAlign: 'left',
      textUnderlinePosition: 'from-font',
      textDecorationSkipInk: 'none',
      color: "rgba(100, 116, 139, 1)",
      marginTop:"2vw",
     

    },
    scanText:{
      fontFamily: 'Roboto, sans-serif',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.2px',
      textAlign: 'left',
      textUnderlinePosition: 'from-font',
      textDecorationSkipInk: 'none',
      color:"rgba(115, 131, 153, 1)",
      marginTop:"3vw"
    },
    scanBtn:{
border:"1px solid  rgba(0, 177, 119, 1)",
padding:"4vw",
borderRadius:"12px",
color: "rgba(0, 177, 119, 1)"


    },



    iteam:{


      fontFamily: 'Roboto, sans-serif',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '18.75px',
    textAlign: 'center',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    color:'rgba(113, 129, 152, 1)'



    },
    price:{


      fontFamily: 'Roboto, sans-serif',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '18.75px',
    textAlign: 'center',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    color:' rgba(0, 177, 119, 1)',
    marginLeft:"19vw"



    }
    ,
    noBtn:{
      backgroundColor: "rgb(0, 177, 119)",
      padding: "3%",
      width: "30vw",
      textAlign: "center",
      color: "white",
      fontWeight: 500,
      fontSize: "5vw",
      borderRadius: "8px",

      

    },
    yesBtn:{
     
      padding: "3%",
      width: "30vw",
      textAlign: "center",
      color: "rgb(0, 177, 119)",
      fontWeight: 500,
      fontSize: "5vw",
      borderRadius: "8px",
      border:"1px solid rgb(0, 177, 119)"

      
    }


};


function ActiveOrder(props) {
const {  setBusyPopupFlag,
  busyPopupFlag,
  machineError,fetchCode} =props

const navigate=useNavigate()
const {orderId,status}=useParams()
console.log("cancleErrorflag",props?.cancleErrorflag)

const goToPickUpOrder=(e,orderID,machineId)=>{
  
  localStorage.setItem("contactLessOrderID",orderID)
  localStorage.setItem("contactLessMachineID",machineId)
  navigate("/pickupOrder")
}

const handleBack=()=>{
navigate(`/pickupOptions/${orderId}`)
}

const MyHeader = () => {
  return (
    <Box display="flex" alignItems="center" p={1} sx={{ background: "#fae14b" ,position: "fixed",width:"100%",zIndex: "999"}}>
      <IconButton onClick={handleBack}>
        <ArrowBackIcon />
      </IconButton>
      <Typography variant="h6" sx={{ fontWeight: 500, ml: 1 }}>
        Active Order
      </Typography>
    </Box>
  );
};

 const [diffInMs,setDiffInMs]=useState()


 function Truncatedproname({ text, limit ,fontSize}) {
  if (text&&text.length <= limit) {
    return <span style={{ fontSize: "14px", color: "#384F6F" }}>{text}</span>;
  }
  return (
    <span style={{ fontSize: fontSize?fontSize:"14px", color: "#384F6F" }}>{`${text&&text.substring(
      0,
      limit
    )}`}</span>
  );
}

function TruncatedVmadd({ text, limit }) {
  if (text?.length <= limit) {
    return <span style={{color: "rgba(113, 129, 152, 1)"
    }}>{text}</span>;
  }
  return (
    <span style={{color: "rgba(113, 129, 152, 1)"
    }}>{`${text&&text.substring(
      0,
      limit
    )}`}</span>
  );
}
function TruncatedVmName({ text, limit }) {
  if (text.length <= limit) {
    return <span style={{color: "rgba(113, 129, 152, 0.7)"
    }}>{text}</span>;
  }
  return (
    <span style={{color: "rgba(113, 129, 152, 1)"
    }}>{`${text&&text.substring(
      0,
      limit
    )}`}</span>
  );
}
  
  //console.log("ActiveOrderepochtime",props.epochtime)
  const updatetime=()=>{
    //console.log("ActiveOrderepochtime update",props&&props.epochtime&&props.epochtime)
    let alltimer=[]
    props&&props.epochtime&&props.epochtime[0]&&props.epochtime.map((el,index)=>{
      //console.log("ActiveOrderepochtime update hello update")
      const time=(props.epochtime[index] - Date.now())
      const currentMinutes = Math.floor(time / 60000);
      //console.log("timemap",index,currentMinutes)
      alltimer.push(currentMinutes)
      setDiffInMs(alltimer)

    })
    for (let i = 0; i <props&& props.epochtime.length; i++) {
      //console.log("ActiveOrderepochtime update hello update")
      //console.log(`epochtime for Object ${i + 1}: ${props.epochtime[i]}`);
    
     // current epoch time in seconds- currentDate.getTime();
    // current time in minutes
    
    //console.log(" currentMinutes  diffInMs",currentMinutes*60,currentMinutes)
 
    }
  
  }


  const helpFun=(e,order_id)=>{
   console.log("order_id",order_id)
   navigate(`/ordersearch?id=${order_id}`)

  }
   useEffect(()=>{
 updatetime()
},[props.epochtime,diffInMs]) 
  //console.log("props diffInMs----> ",diffInMs)


  let percentage
  let convertPer
  //let remainingMinutes
  //let remainingSeconds
  let mm = 400;
  const [m, setM] = useState(0);
  const [s, setS] = useState(0);
  const [remainingSeconds,setRemainingSeconds]=useState(0)
  const [remainingMinutes,setRemainingMinutes]=useState(0)
  const [minutes,setMinutes]=useState(0);
  const [count, setCount] = useState(0);


 useEffect(() => {
  // Function to recalculate the value
  const recalculateValue = () => {
    // Perform the calculation here
   
   
    updatetime()
    //setValue(newValue);
  };
  

 

  // Schedule the recalculation every 1 minute (60000 milliseconds)
  const intervalId = setInterval(recalculateValue, 60000);

  // Clean up the interval on component unmount
  return () => {
    clearInterval(intervalId);
  };
}, [/* props.epochtime,diffInMs */]);


const CreatedTime=(props)=>{

  //console.log("TIME",props.time)
  var date = new Date(props.time);

  // Convert to Indian time string
  var indianTime = date.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
  
  //console.log("indianTime",indianTime);
  




  

return(


  <>
  <>{indianTime}</>
  </>
)

 }




/*  const intervalId = setInterval(() => {
    
  console.log("props.currentMinutes",props.currentMinutes)
  },1000);    */

useEffect(()=>{


  


  },[props.currentMinutes])
















  const machineId = localStorage.getItem("machineId");

  //console.log("props Orders", props);
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  const navigator = useNavigate();




  return (
    <>
    {props?.loader&&<WaitingLoder/>}
      {busyPopupFlag&&<BusyMachineModal setBusyPopupFlag={setBusyPopupFlag} machineError={machineError}/>}
     <MyHeader/>
  
      {/* Cancel Order Modal */}

      {(props?.cancleflag) && (
    <CancelOrderModal setCancleflag={props?.setCancleflag} CancleOrder={props?.CancleOrder}/>
      )}
  
      {/* Cancel Error Modal */}
      {(props?.cancleErrorflag) && (
  <CancelErrorModal props={props?.cancleErrorflag} setCancleErrorflag={props?.setCancleErrorflag} cancleErrorMsg={props?.cancleErrorMsg} cancleErrorflag={props?.cancleErrorflag} />
      )}
  
      {/* Cancel Success Modal */}
      {(props?.cancleSuccessflag )&& (
    <CancelSuccessModal  setCancleSuccessflag={props.setCancleSuccessflag} cancleSuccessMsg={props.cancleSuccessMsg}/>
      )}
  
  
      {/* Active Orders */}
      {UserJWTAuth ? (
        <div style={{overflowY:"scroll",overflowX:"hidden",}}>
        
                  {/* Order details */}
             
  
  <div style={modalStyles.overlay}>
    <div style={modalStyles.modal}>
      <div style={{padding:"5%"}}>
      <div style={{display:"flex",       "align-items": "flex-end",
    "justify-content": "space-between"}}>
      <div>
      <h2 style={modalStyles.companyName}><TruncatedVmadd  text={props?.activeOrder?.vendingMachineAddress} limit={40}/></h2>
      <p style={modalStyles.address}><TruncatedVmadd text={props?.activeOrder?.vendingMachineAddress} limit={40}/>

      </p>
      </div>
      <div >

<CircularTimer createdAt={props?.activeOrder?.createdAt} pickupTime={props?.activeOrder?.pickupTime}/>
        </div>
      </div>
      </div>
      {status=="false"&&<div style={modalStyles.pickupCodeSection} >
        <div style={{padding:"20px",paddingBottom:0,  }}>
        <h1 style={modalStyles.textPickupCode}>To pick your order</h1>
        <p style={modalStyles.textPickupCodeSub}>Enter the pickup code on the vending machine </p>
        <div style={{padding:"3vw",marginTop: "0vw",paddingTop:"0vw"}}>
        <div style={{display:"flex",    justifyContent: "center"}}>
          <div style={{ marginLeft:"2vw", border: "1px solid rgba(0, 177, 119, 0.5)",  width: "16vw",padding:"3vw",
textAlign: "center",borderRadius:"8px"}}>
  <p style={{fontSize:"24px",fontWeight:"700",color:"rgba(0, 177, 119, 0.5)"}}>
  {props?.activeOrder?.dcCode[0]}
</p>


          </div>
          <div style={{ marginLeft:"2vw",padding:"3vw",  border: "1px solid rgba(0, 177, 119, 0.5)",  width: "16vw",
textAlign: "center",borderRadius:"8px"}}>
  <p style={{fontSize:"24px",fontWeight:"700",color:"rgba(0, 177, 119, 0.5)"}}>
  {props?.activeOrder?.dcCode[1]}
</p>


          </div>
          <div style={{  marginLeft:"2vw",padding:"3vw",  border: "1px solid rgba(0, 177, 119, 0.5)",  width: "16vw",
textAlign: "center",borderRadius:"8px"}}>
  <p style={{fontSize:"24px",fontWeight:"700",color:"rgba(0, 177, 119, 0.5)"}}>
  {props?.activeOrder?.dcCode[2]}
</p>


          </div>
          <div style={{  marginLeft:"2vw", padding:"3vw", border: "1px solid rgba(0, 177, 119, 0.5)",  width: "16vw",
textAlign: "center",borderRadius:"8px"}}>
  <p style={{fontSize:"24px",fontWeight:"700",color:"rgba(0, 177, 119, 0.5)"}}>
  {props?.activeOrder &&props?.activeOrder?.dcCode[3]}
</p>


          </div>
        </div>


        </div>

        </div>
      

      </div>}
{   status=="true"&&<> <div style={{position:"relative",left: "85vw", top: "-4vw"
}}>
{/*   <div style={{width:"30px",height:"30px",background:"rgb(242 248 248)",borderRadius:"30px"}}>

  </div> */}
  </div>
  <div style={{position:"relative",left: "-3vw", top: "-11vw"
}}>
{/*   <div style={{width:"30px",height:"30px",background:"rgb(242 248 248)",borderRadius:"30px"}}>

  </div> */}
 
  </div></>}
  <div style={{padding:"20px",    paddingTop:"0",marginTop: status=="true"?"-30":"0px","margin-bottom": "-11vw"}}>
    <div style={{/* display: "flex" */justifyContent:"space-between"}}>
    <h1 style={{color: "rgba(113, 129, 152, 1)"}}> 
    Order ID:# 
    <span style={{color:"rgba(56, 79, 111, 1)"}}>{props?.activeOrder?.orderId}</span>
    </h1>
    <p style={{color:"rgba(113, 129, 152, 1)"}}>
    <CreatedTime time= {props?.activeOrder?.createdAt}/>
    </p>
    </div>
    </div>
          {/* Line Items */}
          <div style={{padding:"5%"}}>
                  {props?.activeOrder?.lineItems.map((el, idx) => (

                  <div style={{border:"1px solid rgba(56, 79, 111, 0.08)",borderRadius:"10px",    marginTop:"5%"}}>
                    <div style={{padding:"5%",display:"flex"}}>
                    <img style={{width:"65px"}}  src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${el.imageUrl}`}/>
                    <div style={{marginLeft:"20px"}}>
                    <h1 style={{color:"rgba(56, 79, 111, 1)"}}><Truncatedproname text={el.productName} limit={25} fontSize={"16px"}/></h1>
                    <div>
                      <div style={{display:"flex",marginTop:"22px"}}>
                      <h1 style={modalStyles.iteam}>{el.unitCount} Items</h1>
                      <h1 style={modalStyles.price}>₹{""}
                      {el.offerPrice.toFixed(2)}</h1>
                      </div>
                    </div>
                    </div>
                    </div>
              
              
                  </div>
                  
                  ))}
                  </div>
                  <div style={{padding:"5%",paddingTop:"0vw"}}>
                  <div style={{border:"1px solid rgba(56, 79, 111, 0.08)",padding:"5%",borderRadius:"10px"}} >
                  <div style={{display:"flex", justifyContent:"space-between"}}><h1 style={{color:"background: rgba(56, 79, 111, 1)"}}>Grand Total</h1>
                  <h1 style={{color:"background: rgba(56, 79, 111, 1)"}}>₹ {props?.activeOrder?.amount.toFixed(2) }</h1>
                  
                  </div>
                  </div>
                  </div>
                  <div  style={{padding:"5%"}}>
                    <div style={{display:"flex",  justifyContent:"space-between" }}>

                    <div style={{    height: "13vw",
    border: "1px solid rgba(113, 129, 152, 0.38)",
    padding: "4%",
    borderRadius: "10px",
    textAlign: "center",
    width: "39vw"}} onClick={(e) => props.CancleOrderset(e,props?.activeOrder?.orderId)}>
                    Cancel Order

                      </div>

                       <div onClick={(e)=>{helpFun(e,props?.activeOrder?.orderId)}} style={{    height: "13vw",
    border: "1px solid rgba(113, 129, 152, 0.38)",
    padding: "4%",
    borderRadius: "10px",
    textAlign: "center",
    width: "39vw"}}>
                    Help & Support

                      </div> 
                      
</div>

                  </div>

    </div>

  
    
  </div>
  
 

  {status=="true"&& <SwipeToVend fetchCode={fetchCode}/>}
            
                </div>
           
       
      ) : (
        <div style={{ marginTop: "50%", textAlign: "center" }}>
          <h1>Something Went Wrong</h1>
        </div>
      )}
    </>
  );
  
      
 
}

export default ActiveOrder;
